import { render, staticRenderFns } from "./navigator-widget-ui.vue?vue&type=template&id=17946240&scoped=true&"
import script from "./navigator-widget-ui.ts?vue&type=script&lang=ts&"
export * from "./navigator-widget-ui.ts?vue&type=script&lang=ts&"
import style0 from "./navigator-widget-ui.scss?vue&type=style&index=0&id=17946240&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17946240",
  null
  
)

export default component.exports